export interface Validator {
  id: string;
  sistEndret: number;
  name: string;
}

export enum ValidatorType {
  NotBlank = 'NotBlank'
}
